/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: NinaCoachChatTakeOverMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_NINA_COACH_CHAT_TAKE_OVER);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler'] = com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","NinaCoachChatTakeOverMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 * @this com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler.prototype.processMessage = function (message) {
	this.setAgent(
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID),
		message,
		false
	);

	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) !== "1") {
		com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("",
			message.getProperty(com.inq.flash.client.data.MessageFields.KEY_DISPLAY_TEXT),
			com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,-1,
			null, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler} */
com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler;
